module.exports = __webpack_public_path__ + "assets/img/typeIcon-4-yellow.b9bc48d7.svg";